export default __webpack_public_path__ + "static/media/kids_podium.33f898fc.jpg";